import { styled } from '@styles';
import { Card } from 'react-bootstrap';

export const Wrapper = styled.div``;

export const RedCard = styled(Card.Header)`
  background-color: #f2f3f5;
  color: black;
`;
